const randChar = () => "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678901234567890123456789".charAt(
    Math.floor(Math.random() * 82)
);

export const generateShortId = (length = 12) => [...Array(length)].map(() => randChar()).join("");
